import { render, staticRenderFns } from "./RemunerationToCash.vue?vue&type=template&id=822e05f4&scoped=true&"
import script from "./RemunerationToCash.vue?vue&type=script&lang=js&"
export * from "./RemunerationToCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822e05f4",
  null
  
)

export default component.exports